import { Router } from '@/router';
import { LOGOUT_EVENT_NAME, LOGOUT_MESSAGE_CHANNEL } from '@/utils/authority';
import { handleError } from '@/utils/errors';
import { PhoneWidgetProvider } from '@propify/admin-components';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import ConfigProvider from 'antd/es/config-provider';
import enUS from 'antd/es/locale/en_US';
import { useEffect } from 'react';
import { ThemeProvider } from 'styled-components';

const queryClient = new QueryClient();

const onCreatePhoneWidgetError = (error: unknown) =>
  handleError(error, { toastMessage: 'There was an error setting up Agent Mode' });

function App() {
  useEffect(() => {
    const channel = new BroadcastChannel(LOGOUT_MESSAGE_CHANNEL);

    channel.onmessage = (event) => {
      if (event.data === LOGOUT_EVENT_NAME) {
        queryClient.clear();
      }
    };

    return () => {
      channel.close();
    };
  }, []);

  return (
    <ThemeProvider theme={{}}>
      <ConfigProvider locale={enUS}>
        <QueryClientProvider client={queryClient}>
          <PhoneWidgetProvider onCreatePhoneWidgetError={onCreatePhoneWidgetError}>
            <Router />
          </PhoneWidgetProvider>
        </QueryClientProvider>
      </ConfigProvider>
    </ThemeProvider>
  );
}

export default App;
